// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2aB1u","label":"SetPasswdForm_label__1CN56"};